import { FC } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Heading = styled.h1(({ theme }) => {
  const { color, type } = theme;

  return `
    font-size: ${type.size.huge};
    color: ${color.grayscale[0]};
    margin-bottom: 3rem;
    text-align: center;
  `;
});

const Card = styled.div(({ theme }) => {
  const { color, shadow } = theme;

  return `
    background-color: ${color.grayscale[1000]};
    border-radius: 16px;
    box-shadow: ${shadow.dialog};
    padding: 38px 32px;
    width: max(65%, 928px);
    margin: 0 auto;

    a {
      color: ${color.primary.regular};
    }
  `;
});

const PasswordSuccess: FC = () => {
  return (
    <>
      <Heading>Change Password</Heading>
      <Card>
        <h3>Success</h3>
        Your password has been changed. <Link to="/">Click here to continue.</Link>
      </Card>
    </>
  );
};

export default PasswordSuccess;
